import { IWordCloud } from '@nocode/types';
import React from 'react';
import { SafeAreaView, Image } from 'react-native';
import getWordFrequencies, {
  createBlockedItemsSet,
  defaultColors,
} from './hook';
import queryString from 'query-string';
import WebWordCloud from './WebWordCloud';
import WordCloudImage from '../../../assets/images/word-cloud.png';
const WordCloud: React.FC<IWordCloud> = (props) => {
  const { attributes, onPress, height, zIndex, dataBinding, width, style } =
    props;
  const { backgroundColor } = style;
  const search = queryString.parse(window?.location?.search);
  const target = search?.target;
  const isCanvas = !target;
  if (isCanvas) {
    return (
      <>
        <SafeAreaView>
          <Image
            source={WordCloudImage}
            style={{
              height: height,
              width: width,
              backgroundColor: backgroundColor,
            }}
          />
        </SafeAreaView>
      </>
    );
  } else {
    if (dataBinding?.length) {
      const wordsRes: string = dataBinding
        .map((obj) => obj['words.words'])
        .join(' ');
      const { rotation, padding, blockItems } = attributes;
      const blockedItems: Set<string> = createBlockedItemsSet(blockItems ?? '');
      let words: any = getWordFrequencies(wordsRes, blockedItems);
      return (
        <>
          <SafeAreaView>
            <WebWordCloud
              words={words}
              width={width}
              height={height}
              rotate={() => {
                return rotation && rotation.enabled ? 1 : 0;
              }}
              colors={defaultColors()}
              backgroundColor={backgroundColor}
              padding={padding ? padding.paddingSize : 1}
            />
          </SafeAreaView>
        </>
      );
    }
    return <></>;
  }
};

export default WordCloud;
